import { render, staticRenderFns } from "./realTombPicList.vue?vue&type=template&id=748da64b&scoped=true"
import script from "./realTombPicList.vue?vue&type=script&lang=js"
export * from "./realTombPicList.vue?vue&type=script&lang=js"
import style0 from "./realTombPicList.vue?vue&type=style&index=0&id=748da64b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748da64b",
  null
  
)

export default component.exports